export default __webpack_public_path__ + "static/media/1838.ce3f7865.png";